import { isSharedListAdmin, canEditSharedLists, canEditSharedTaxRollSummary } from '../../util/shared/sharedListAdmin';

export default {
  computed: {

    isSharedListAdmin() {
      return isSharedListAdmin();
    },
    canEditSharedList() {
      return canEditSharedLists();
    },
    canEditSharedTaxRollSummary() {
      return canEditSharedTaxRollSummary();
    },
    canAddSharedTaxRollSummary() {
      return canEditSharedTaxRollSummary();
    },
    canDeleteSharedTaxRollSummary() {
      return canEditSharedTaxRollSummary();
    },
    canAddToSharedList() {
      return this.canEditSharedList;
    },
    canDeleteFromSharedList() {
      return this.canEditSharedList;
    },
  },
};
